import { DeviceAttributeType, getDeviceAttributeTypeByName } from "./DeviceAttribute";
import { DeviceAttributeContainer } from "./DeviceAttributeContainer";
import { COM_BOX_ID, HYDRY_MINI_ID } from "./DeviceSettingsManager";

/**
 * Template for a device including name, ID, and associated attributes.
 */
export interface DeviceTemplate {
  deviceName: string;
  id: string;
  categoryId: string;
  // on creation of new template, attributes are calculated from meter value
  deviceAttributes: DeviceAttributeContainer[];
  isEditable: boolean;
  sortIndex: number; 
}

/**
 * Determines if the specified device attribute type relates to power consumption.
 * @param {DeviceAttributeType} attributeType - The type of device attribute to check.
 * @returns {boolean} True if the attribute type relates to power consumption, false otherwise.
 */
export function isPowerConsumptionAttribute(attributeType: DeviceAttributeType): boolean {
  switch (getDeviceAttributeTypeByName(attributeType.toString())) {
    case DeviceAttributeType.METER_READING:
    case DeviceAttributeType.OPERATING_HOURS:
    case DeviceAttributeType.OPERATING_HOURS_FROM_ASSIGNMENT:
      return true;
    default:
      return false;
  } 
}

/**
 * Selects the power consumption mode for a device based on its attributes.
 * @param {DeviceTemplate} deviceTemplate - The device template to check.
 * @returns {DeviceAttributeType | null} The device attribute type related to power consumption, or null if none.
 */
export function selectedPowerConsumptionMode(deviceTemplate: DeviceTemplate): DeviceAttributeType | null {
  for (const deviceAttribute of deviceTemplate.deviceAttributes) {
    if (isPowerConsumptionAttribute(deviceAttribute.attributeType)) {
      return getDeviceAttributeTypeByName(deviceAttribute.attributeType.toString()) ?? null;
    }
  }
  return null;
}

export function canBeUsedAsElectricityMeterForOtherDevices(deviceTemplate: DeviceTemplate): boolean {
  if (deviceTemplate.id == COM_BOX_ID || deviceTemplate.id == HYDRY_MINI_ID) {
    return true;
  }

  for (const deviceAttributeContainer of deviceTemplate.deviceAttributes) {
    const deviceAttributeType = deviceAttributeContainer.attributeType;
    if (deviceAttributeType === DeviceAttributeType.ELECTRICITY_METER_FOR_OTHER_DEVICES) {
      return true;
    }
  }
  return false
}